import NewOrderPaymentForm from "../containers/NewOrderPaymentForm"
import OrderApprovalForm from "../containers/OrderApprovalForm"
import ReactFacebookWidget from "../../../components/ReactFacebookWidget"
import { notifyGAnalyticsAboutFinishedOrder } from "../lib/GAnalyticsTools"
import { notifyFbAnalyticsAboutFinishedOrder } from "../lib/FbAnalyticsTools"

let GAnalyticsNotified = false
let FbAnalyticsNotified = false

export default class OrderSummary extends React.Component {
  componentWillReceiveProps({ order }) {
    if (order.data._hasOrderJustFinished) {
      if (!GAnalyticsNotified) {
        notifyGAnalyticsAboutFinishedOrder(order)
        GAnalyticsNotified = true
      }
      if (!FbAnalyticsNotified) {
        notifyFbAnalyticsAboutFinishedOrder(order)
        FbAnalyticsNotified = true
      }
    }
  }

  renderContents() {
    const order = this.props.order
    const { i18n_scope, i18n_params } = order

    if (order.data.status == "waiting_for_company_approval" && order.data.confirmation_installment_before_company_approval) {
      return (
        <div>
          <p>{I18n.tt(`${i18n_scope}.thank_you_for_order_request`, i18n_params)}</p>

          <p>
            <strong>{I18n.tt(`${i18n_scope}.your_order_id`, i18n_params)}:</strong> {order.data.id}<br />
            <strong>{I18n.tt(`${i18n_scope}.customer_full_name`, i18n_params)}:</strong> {order.data.customer_full_name}<br />
          </p>

          <p>{I18n.tt(`${i18n_scope}.order_is_waiting_for_company_approval`, i18n_params)}</p>

        <h4>{I18n.tt(`${i18n_scope}.further_details`, i18n_params)}</h4>
          <p>{I18n.tt(`${i18n_scope}.after_payment_had_been_approved_company_received_your_order_request_and_has_to_approve_it`, i18n_params)}</p>
        <p>{I18n.tt(`${i18n_scope}.when_company_approves_ok_when_company_rejects_we_will_refund_your_online_deposit`, i18n_params)}</p>
        <p>{I18n.tt(`${i18n_scope}.when_company_approves_we_will_send_order_confirmation`, i18n_params)}</p>
        </div>
      );
    } else if (order.data.status == "waiting_for_company_approval" && order.data.confirmation_installment_after_company_approval) {
      return (
        <div>
          <p>{I18n.tt(`${i18n_scope}.thank_you_for_order_request`, i18n_params)}</p>

          <p>
            <strong>{I18n.tt(`${i18n_scope}.your_order_id`, i18n_params)}:</strong> {order.data.id}<br />
            <strong>{I18n.tt(`${i18n_scope}.customer_full_name`, i18n_params)}:</strong> {order.data.customer_full_name}<br />
          </p>

          <p>{I18n.tt(`${i18n_scope}.we_sended_order_request_confirmation_to_your_email`, i18n_params)}</p>

          <p>{I18n.tt(`${i18n_scope}.order_is_waiting_for_company_approval`, i18n_params)}</p>

        <h4>{I18n.tt(`${i18n_scope}.further_details`, i18n_params)}</h4>
          <p>{I18n.tt(`${i18n_scope}.company_received_your_order_request_and_has_to_approve_it`, i18n_params)}</p>
          <p>
            {I18n.tt(`${i18n_scope}.when_company_approves_we_will_send_online_payment_email`, i18n_params)}
            <br />
            {I18n.tt(`${i18n_scope}.if_no_online_payment_your_order_will_be_cancelled`, i18n_params)}
          </p>
        </div>
      );
    } else if (order.data.status == "waiting_for_company_approval" && !order.data.has_confirmation_installment) {
      return (
        <div>
          <p>{I18n.tt(`${i18n_scope}.thank_you_for_order_request`, i18n_params)}</p>

          <p>
            <strong>{I18n.tt(`${i18n_scope}.your_order_id`, i18n_params)}:</strong> {order.data.id}<br />
            <strong>{I18n.tt(`${i18n_scope}.customer_full_name`, i18n_params)}:</strong> {order.data.customer_full_name}<br />
          </p>

          <p>{I18n.tt(`${i18n_scope}.we_sended_order_request_confirmation_to_your_email`, i18n_params)}</p>

          <p>{I18n.tt(`${i18n_scope}.order_is_waiting_for_company_approval`, i18n_params)}</p>

        <h4>{I18n.tt(`${i18n_scope}.further_details`, i18n_params)}</h4>
          <p>{I18n.tt(`${i18n_scope}.company_received_your_order_request_and_has_to_approve_it`, i18n_params)}</p>
        <p>{I18n.tt(`${i18n_scope}.when_company_approves_we_will_send_order_confirmation`, i18n_params)}</p>
        </div>
      );
    } else if (order.data.waiting_for_confirmation_online_payment && order.data._hasPaymentFailed) {
      return (
        <div>
          <p>{I18n.tt(`${i18n_scope}.online_payment_failed`, i18n_params)}</p>

          <a href={order.data.url} className="btn btn-primary btn-lg">{I18n.tt(`${i18n_scope}.repeat_payment`, i18n_params)}</a>
        </div>
      );
    } else if (order.data.waiting_for_confirmation_online_payment && order.data._hasPaymentFinished) {
      return (
        <div>
          <p>{I18n.tt(`${i18n_scope}.thank_you_for_order_request`, i18n_params)}</p>

          <p>
            <strong>{I18n.tt(`${i18n_scope}.your_order_id`, i18n_params)}:</strong> {order.data.id}<br />
            <strong>{I18n.tt(`${i18n_scope}.customer_full_name`, i18n_params)}:</strong> {order.data.customer_full_name}<br />
          </p>

          <p>{I18n.tt(`${i18n_scope}.order_is_waiting_for_online_payment_info`, i18n_params)}</p>

          {(order.data.confirmation_installment_before_company_approval &&
            <div>
              <h4>{I18n.tt(`${i18n_scope}.further_details`, i18n_params)}</h4>
              <p>{I18n.tt(`${i18n_scope}.when_payment_gets_approved_company_will_receive_your_order_request_and_has_to_approve_it`, i18n_params)}</p>
            <p>{I18n.tt(`${i18n_scope}.when_company_approves_we_will_send_order_confirmation`, i18n_params)}</p>
            </div>
          ) ||
            <p>{I18n.tt(`${i18n_scope}.when_payment_gets_approved_we_will_send_order_confirmation`, i18n_params)}</p>
          }
        </div>
      );
    } else if (order.data.waiting_for_confirmation_online_payment && !order.data._hasPaymentFinished) {
      return (
        <div>
          {(order.data.requires_company_approval && !order.data.confirmation_installment_after_company_approval &&
            <p>{I18n.tt(`${i18n_scope}.company_approved_your_order_request`, i18n_params)}</p>
          ) ||
            <p>{I18n.tt(`${i18n_scope}.thank_you_for_order_request`, i18n_params)}</p>
          }

          <NewOrderPaymentForm />
        </div>
      );
    } else if (order.data.status == "approved") {
      return (
        <div>
          <p>{I18n.tt(`${i18n_scope}.thank_you_for_order`, i18n_params)}</p>

          {(order.data.requires_company_approval && !order.data.confirmation_installment_after_company_approval &&
            <p>{I18n.tt(`${i18n_scope}.company_approved_your_order_request`, i18n_params)}</p>
          ) ||
            (order.data.has_confirmation_installment && order.data.confirmation_installment_paid_amount_sum.value &&
              <p>{I18n.tt(`${i18n_scope}.we_received_all_required_order_informations_and_online_payment`, i18n_params)}</p>
            ) ||
              <p>{I18n.tt(`${i18n_scope}.we_received_all_required_order_informations`, i18n_params)}</p>
          }

          <p>{I18n.tt(`${i18n_scope}.your_order_is_fully_confirmed`, i18n_params)}</p>

          {!!order.data.has_remaining_bank_wire_installment &&
            <div>
              <hr />

              <p><strong>{I18n.tt(`${i18n_scope}.additional_bank_wire_deposit_required`, i18n_params)}</strong> {I18n.tt(`${i18n_scope}.please_pay_bank_wire_deposit`, i18n_params)}</p>
              <p>{I18n.tt(`${i18n_scope}.bank_wire_deposit_details`, i18n_params)}: {order.data.upcoming_bank_wire_transfer_details}</p>
              <p>{I18n.tt(`${i18n_scope}.bank_wire_deposit_instructions`, i18n_params)}</p>
              <p><strong>{I18n.tt(`${i18n_scope}.bank_wire_deposit_deadline_warning`, i18n_params)}</strong></p>

              <hr />
            </div>
          }

          <p>
            {I18n.tt(`${i18n_scope}.we_sended_order_confirmation_to_your_email`, i18n_params)}
            &nbsp;
            {I18n.tt(`${i18n_scope}.you_can_download_order_data_confirmation_using_button_below_as_well`, i18n_params)}
          </p>

          <a href={order.pdf_url} className="btn btn-primary btn-lg" target="_blank">
            <i className="fa fa-download"></i> {I18n.tt(`${i18n_scope}.download_order_data_confirmation`, i18n_params)}
          </a>
        </div>
      );
    } else if (order.data.status == "waiting_for_customer_approval") {
      return (
        <div>
          <p>
            {I18n.tt(`fe.NewOrderView.order_is_waiting_for_your_approval`, i18n_params)}
            &nbsp;
            {I18n.tt(`fe.NewOrderView.click_below_to_approve`, i18n_params)}
          </p>

          <OrderApprovalForm order={order} />
        </div>
      )
    } else if (order.data.status == "finished") {
      return (
        <div>
          <p>{I18n.tt(`fe.NewOrderView.order_is_finished`, i18n_params)}</p>

          {!order.data.has_review && (
            <div>
              <p>{I18n.tt(`fe.NewOrderView.we_havent_received_your_review_yet`, i18n_params)}</p>
              <a className="btn btn-lg btn-primary" href={order.new_review_url}>{I18n.tt(`fe.NewOrderView.write_a_review`, i18n_params)}</a>
            </div>
          )}
        </div>
      )
    } else {
      return (
        <div>
          <h4>{I18n.tt(`${i18n_scope}.order_status`, i18n_params)}: {order.data.status_i18n}</h4>
        </div>
      );
    }
  }

  render() {
    return (
      <div className="order-summary">
        <h2>{I18n.t("fe.NewOrderView.order_name", {
          id: this.props.order.data.id,
        })}</h2>

        {this.renderContents()}

        {!!this.props.order.product && this.props.order.data.app_config.marketplace && !this.props.order.data._hasPaymentFailed && !(this.props.order.data.waiting_for_confirmation_online_payment && this.props.order.data.confirmation_installment_after_company_approval && this.props.order.data.requires_company_approval) && (
          <ReactFacebookWidget>
            <hr />
            <p>{I18n.tt(`fe.NewOrderView.marketplace.thank_you_for_order_and_share_to_fb`)}</p>
            <div className="fb-like" data-href={this.props.order.product.url} data-layout="standard" data-action="like" data-show-faces="true" data-share="true"></div>

            <p>{I18n.tt(`fe.NewOrderView.marketplace.share_us_to_friends`)}</p>
            <div className="fb-page" data-href="https://www.facebook.com/socialtravelpl/" data-small-header="true" data-adapt-container-width="true" data-hide-cover="false" data-show-facepile="true"></div>
          </ReactFacebookWidget>
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/webpack/frontend/features/NewOrderView/components/OrderSummary.jsx